<div
	*clientScreen="let isDesktop = isDesktop"
	class="container ov-a"
	[class.is-desktop]="isDesktop"
	(click)="stopEvent($event)"
>
	<ng-content></ng-content>
</div>
